module.exports = __webpack_public_path__ + "static/img/Well_Done.86bc73a6.png";